// extracted by mini-css-extract-plugin
module.exports = {"searchresult":"searchresult_searchresult__PyZ2M","userinfo":"searchresult_userinfo__3f3gD"};